import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ExcelModule, GridModule, PDFModule } from '@progress/kendo-angular-grid';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { IntlModule } from '@progress/kendo-angular-intl';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { DateInputsModule } from "@progress/kendo-angular-dateinputs";
import { UploadsModule } from "@progress/kendo-angular-upload";
import { NotificationModule } from "@progress/kendo-angular-notification";
import { TooltipsModule } from '@progress/kendo-angular-tooltip';
import { TreeViewModule } from "@progress/kendo-angular-treeview";
import { LabelModule } from "@progress/kendo-angular-label";
import { IconsModule } from '@progress/kendo-angular-icons';

// Component
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { FooterComponent } from './components/footer/footer.component';
import { LetterHeadComponent } from '../common/component/letterhead/letterhead.component';
import { PagerModule } from '@progress/kendo-angular-pager';
import { ChartModule, ChartsModule } from "@progress/kendo-angular-charts";
import { NgxDropzoneModule } from 'ngx-dropzone';
import { HistoryComponent } from '../common/history/history.component';
import { DocumentTabComponent } from '../common/component/document-tab/document-tab.component';
import { SingleBarChartComponent } from '../common/component/single-bar-chart/single-bar-chart.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CustomDatePipeModule } from './utility/local-date-time-pipe.module';
import { CereusDialogComponent } from './components/cereus-dialog/cereus-dialog.component';
import { CereusAnnouncementsComponent } from './components/cereus-announcements/cereus-announcements.component';
import { CommonMessageComponent } from '../common/component/common-message/common-message.component';
import { CereusPermissionComponent } from './components/cereus-permission/cereus-permission.component';
import { CereusCommonTabComponent } from './components/cereus-common-tab/cereus-common-tab.component';
import { ContextMenuModule } from '@progress/kendo-angular-menu';
import { CereusNotesComponent } from './components/cereus-notes/cereus-notes.component';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { CommonVobReportComponent } from '../common/component/common-vob-report/common-vob-report.component';
import { CallLogDialogComponent } from '../common/component/call-log-dialog/call-log-dialog.component';
import { EditorModule } from "@progress/kendo-angular-editor";
import { PhoneDialerComponent } from '../common/component/phone-dialer/phone-dialer.component';
import {
    MonthViewComponent,
    SchedulerComponent, SchedulerModule
} from '@progress/kendo-angular-scheduler';
import { CustomNotificationComponent } from './components/app-custom-notification/app-custom-notification.component';
import { NgxGraphModule } from '@swimlane/ngx-graph';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ButtonGroupComponent, ButtonGroupModule } from '@progress/kendo-angular-buttons';
import { ReportFilterButtonComponent } from '../common/component/report-filter-button/report-filter-button.component';
import { ReportFilterComponent } from '../common/component/report-filter/report-filter.component';
import { VobPdfExportComponent } from '../modules/auth/services/vob-pdf-export/vob-pdf-export.component';

@NgModule(
    {
        declarations:
            [
                HeaderComponent,
                SidebarComponent,
                FooterComponent,
                LetterHeadComponent,
                HistoryComponent,
                DocumentTabComponent,
                SingleBarChartComponent,
                CereusDialogComponent,
                CereusAnnouncementsComponent,
                CommonMessageComponent,
                CereusPermissionComponent,
                CereusCommonTabComponent,
                CereusNotesComponent,
                CommonVobReportComponent,
                CallLogDialogComponent,
                VobPdfExportComponent,
                PhoneDialerComponent,
                CustomNotificationComponent,
                ReportFilterButtonComponent,
                ReportFilterComponent
            ],
        exports: [
            HeaderComponent,
            SidebarComponent,
            FooterComponent,
            LetterHeadComponent,
            FormsModule,
            IconsModule,
            ReactiveFormsModule,
            RouterModule,
            DocumentTabComponent,
            DropDownsModule,
            GridModule,
            InputsModule,
            LayoutModule,
            IntlModule,
            DialogsModule,
            PDFModule,
            ExcelModule,
            DateInputsModule,
            UploadsModule,
            NotificationModule,
            PagerModule,
            NgxDropzoneModule,
            TooltipsModule,
            TreeViewModule,
            ChartModule,
            ChartsModule,
            HistoryComponent,
            LabelModule,
            SingleBarChartComponent,
            NgxSpinnerModule,
            CustomDatePipeModule,
            CereusDialogComponent,
            CereusAnnouncementsComponent,
            CommonMessageComponent,
            CereusPermissionComponent,
            CereusCommonTabComponent,
            ContextMenuModule,
            CereusNotesComponent,
            PDFExportModule,
            CommonVobReportComponent,
            CallLogDialogComponent,
            VobPdfExportComponent,
            EditorModule,
            PhoneDialerComponent,
            SchedulerComponent,
            MonthViewComponent,
            CustomNotificationComponent,
            ButtonGroupComponent,
            ReportFilterButtonComponent,
            ReportFilterComponent
        ],
        imports: [
            RouterModule,
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            DropDownsModule,
            GridModule,
            InputsModule,
            LayoutModule,
            IntlModule,
            IconsModule,
            DialogsModule,
            PDFModule,
            ExcelModule,
            DateInputsModule,
            UploadsModule,
            NotificationModule,
            PagerModule,
            ChartModule,
            ChartsModule,
            TooltipsModule,
            TreeViewModule,
            LabelModule,
            NgxSpinnerModule,
            CustomDatePipeModule,
            ContextMenuModule,
            PDFExportModule,
            EditorModule,
            SchedulerModule,
            NgxGraphModule,
            NgxChartsModule,
            ButtonGroupModule
        ],
        providers: [provideHttpClient(withInterceptorsFromDi())

        ],
        schemas: [CUSTOM_ELEMENTS_SCHEMA,
            NO_ERRORS_SCHEMA
        ],
    })
export class SharedModule { }
